module.exports = __webpack_public_path__ + "img/title2.bd24a9ec.png";